

import { Component, OnDestroy, OnInit } from '@angular/core';
import { DocumentoPct, PdaAct, PdaActModel } from '../../../models/sections/act';
import { pdaConfiguration } from 'src/app/pda/utils/pda-configuration';
import { SectionsServiceTsService } from 'src/app/pda/utils/Service/sections.service.ts.service';
import { ActsServiceTsService } from './Service/acts.service.ts.service';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { Subscription } from 'rxjs';
import { PdaDataStore } from 'src/app/pda/store/pda-store';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';
import { PdaAccessToken, PdaAuthService } from 'src/app/pda/utils/Service/pda-auth.service';
import { mockActsValue } from 'src/app/pda/utils/mock/acts-mock-value';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { DialogService } from 'src/app/core/components/dialog/dialog.service';
import { ViewDocumentDialogComponent } from 'src/app/common/components/view-document-dialog/view-document-dialog.component';
import { Router } from '@angular/router';
import { UrlSettingsCore } from 'src/app/core/configuration/url-settings-core';
import { mimeExtensionMap } from 'src/app/common/components/file-preview/eml/eml-preview.component';
import { MaxPreviewSize, UserProfileFlagStore } from 'src/app/utility/store/user-profile-flag';
import { DocPreviewUtilityService } from 'src/app/common/components/file-preview/doc-preview-utility.service';
import { ConfirmModalComponent } from 'src/app/core/components/dialog/components/confirm-modal/confirm-modal.component';


@Component({
  selector: 'app-pda-section-acts',
  templateUrl: './pda-section-acts.component.html',
  styleUrls: ['./pda-section-acts.component.css']
})
export class PdaSectionActsComponent implements  OnDestroy,OnInit {

  isSelectMode: boolean = false;
  selectMsg: string = "Seleziona dati da importare";
  selectedAct: {idAct: string, documents: DocumentoPct[]} = null;

  tlfSub: Subscription;
  pctSub: Subscription;
  idFascicoloTlf: string;
  config = pdaConfiguration;
  model : PdaActModel;

  constructor(private sectionService: SectionsServiceTsService,
              private actService: ActsServiceTsService,
              private modalNotifyService: ModalNotifyService,
              private viewManager: ViewManagerService,
              private dialog: DialogService,
              private docUtilityService: DocPreviewUtilityService,
              private router: Router, 
              private pdaAuthService: PdaAuthService
            ){
    // this.mockData = mockActsValue();
  }
  ngOnDestroy(): void {
    if(this.tlfSub) this.tlfSub.unsubscribe();
    if(this.pctSub) this.pctSub.unsubscribe();
  }

  ngOnInit(): void {
    this.getIdFascicoloTlf();
    this.getData();
    // this.model = mockActsValue();
  }

  getIdFascicoloTlf () {
    let index = this.config.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_ATTI_FASCICOLO);
    this.idFascicoloTlf = this.config[index].properties.idFascicolo;
  }

  setModel(data: any){
    this.model = { actList : data.atti, dataUltimoAggiornamento : data.dataUltimoAggiornamento };
    PdaDataStore.getInstance().modelActs = this.model;
  }

  async updatePct() {
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    this.sectionService.updatePCT(token, this.idFascicoloTlf, "atti").subscribe(
      data => {
        this.setModel(data);
      }
    )
  }

  getData (){
    if(!PdaDataStore.isSameId(this.idFascicoloTlf)){
      PdaDataStore.cleanupStore();
      PdaDataStore.getInstance().idFascicoloTlf = this.idFascicoloTlf;
    }
    if(!!PdaDataStore.getInstance().modelActs) {
      this.model = PdaDataStore.getInstance().modelActs;
      return
    }

    this.tlfSub = this.sectionService.getIdFascicoloPCT(this.idFascicoloTlf).subscribe({
      next: (idPct) =>{
        if(idPct.length > 0) {
          let pct = idPct[0];
          this.fetchPctFascicoloInfo(pct);
          this.pctSub = this.actService.getAtti(pct.idFascicoloPct).subscribe((data)=>{
            this.setModel(data);
          })
        }
      },error: () =>{}
    })
  }

  private fetchPctFascicoloInfo(data: any) {
    if(PdaDataStore.getInstance().pctInfoFascicolo == null) {
      this.sectionService.getInfoFascicoloPct(data.idFascicoloPct).subscribe(
        fascicoloPctInfo => {
          PdaDataStore.getInstance().pctInfoFascicolo = fascicoloPctInfo;
        }
      );
    }
  }

  changeSelectMode(){

    //Can only select if there are schedules to select

    this.isSelectMode = !this.isSelectMode;

    //if selecting, then empty selected
    if(this.isSelectMode){
      this.selectMsg = "Importa dati";
      this.selectedAct = null;
    }

    //if not selecting, then confirm selected and save
    else{
      this.selectMsg = "Seleziona dati da importare";
      this.onImport();
    }


  }

  async onImport(){
    let docsRequests: {idFascicoloPct: string, idAct: string, idListDocuments: string[]} = {idFascicoloPct: "", idAct: "", idListDocuments: []};
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();


    if(this.selectedAct != null && this.selectedAct.documents.length != 0){
      docsRequests.idFascicoloPct = this.selectedAct.documents[0].idFascicoloPct;
      docsRequests.idAct = this.selectedAct.idAct;
      this.selectedAct.documents.forEach((s) => {
        docsRequests.idListDocuments.push(s.idDocumentoPct);
      });
      this.actService.importDocumenti(token, this.idFascicoloTlf, docsRequests).subscribe(
        data => {
          this.modalNotifyService.customMessage("Documenti importati con successo");
          this.viewManager._refreshNotifiche.next({});
          this.setModel(data);
        }
      );
    }
  }

  isActSelected(act: PdaAct){

    return this.selectedAct != null && this.selectedAct.idAct == act.idAttoPct;

  }

  isActSelectable(act: PdaAct){

    return this.selectedAct == null || this.selectedAct.idAct == act.idAttoPct;

  }

  //only one act can be selected at a time

  //act is enabled

  isDocSelected(doc: DocumentoPct){

    return this.selectedAct != null && this.selectedAct.documents.some(s => s == doc);

  }

  onClickActSelected(act: PdaAct){

    if(this.isActSelected(act)){
      this.onSelectedActRemove(act);
    }
    else{
      this.onSelectedActAdd(act);
    }

  }

  onClickDocSelected(act: PdaAct, doc: DocumentoPct){

    if(this.isDocSelected(doc)) this.onSelectedDocRemove(act, doc);
    else this.onSelectedDocAdd(act, doc);

  }

  onSelectedActAdd(act: PdaAct){
    this.selectedAct = {idAct: act.idAttoPct, documents: act.listDocumentiPct};
  }

  onSelectedActRemove(act: PdaAct){
    this.selectedAct = null;
  }

  onSelectedDocAdd(act: PdaAct, doc: DocumentoPct){

    if(this.selectedAct == null){
      this.selectedAct = {idAct: act.idAttoPct, documents: [doc]};
    }
    else{
      this.selectedAct.documents.push(doc);
    }

  }

  onSelectedDocRemove(act: PdaAct, doc: DocumentoPct){

    this.selectedAct.documents = this.selectedAct.documents.filter(s => s != doc);
    if(this.selectedAct.documents.length == 0){
      this.selectedAct = null;
    }

  }

  accordionToggleClassHandler(){

    return (this.isSelectMode) ? "accordion-toggle" : "accordion-toggle collapsed";

  }

  accordionBodyClassHandler(){

    return (this.isSelectMode) ? "panel-collapse collapse in" : "panel-collapse collapse";

  }

  isDocAlreadyImported(doc: DocumentoPct){
    return doc.importato != null && doc.importato;
  }

  dimensionTranslator(dimensione: number){
    let humanReadable: string = "";
    if(dimensione == 0) humanReadable = "Sconosciuta";
    else{
      let pow = Math.floor(Math.log(dimensione)/Math.log(1024));
      if(pow > 3) pow = 3;
      let stringDimensions = ["","k","M","G"]; //These types of file never weigh more than 30-ish MBs
      humanReadable = (dimensione / Math.pow(1024,pow)).toFixed(2) + " " + stringDimensions[pow] + "B";
    }

    return humanReadable;

  }

  async downloadDirettoDoc(x: DocumentoPct){
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    this.actService.downloadDirettoDoc(token, this.idFascicoloTlf, x.idDocumentoPct, x.refId, PdaDataStore.getInstance().pctInfoFascicolo.registro).subscribe(() => {});
  }

  orderActs(actList: PdaAct[]){
    return actList.sort((a, b) => (b.dataAtto - a.dataAtto));
  }

  getMittente(act: PdaAct){
    let mittente = !!act.nominativoMittente ? this.truncateText(act.nominativoMittente,25) : act.mittente;
    return !!mittente ? mittente : "-";
  }

  truncateText(text: string, threshold: number){
    if(!!text) return text.length > threshold ? text.substring(0,threshold)+'...' : text; else null;
  }

  canViewFile(documento: DocumentoPct){
    let maxPreviewSizeObj = UserProfileFlagStore.getInstance().MAX_PREVIEW_FILE_SIZE;
    const filename = documento.nome;
    const extension = filename.substring(filename.lastIndexOf('.') + 1);
    let maxPreviewSize = !maxPreviewSizeObj ? null : this.getMaxSizetByExtension(maxPreviewSizeObj, extension);
    // controllo che il contenuto del file non superi la dimensione massima consentita
    if(documento.dimensione > Number(!!maxPreviewSize ? maxPreviewSize : documento.dimensione)) {
      return false;
    };
    return documento && 
    documento.nome && (
      documento.nome.includes(".pdf") || 
      documento.nome.includes(".eml") || 
      documento.nome.includes(".zip") ||
      documento.nome.includes(".p7m")
    );
  }

  checkMaxLimitExceeded(documento: DocumentoPct):boolean {
    let maxPreviewSizeObj = UserProfileFlagStore.getInstance().MAX_PREVIEW_FILE_SIZE;
    const filename = documento.nome;
    const extension = filename.substring(filename.lastIndexOf('.') + 1);
    let maxPreviewSize = !maxPreviewSizeObj ? null : this.getMaxSizetByExtension(maxPreviewSizeObj, extension);
    if(documento.dimensione > Number(!!maxPreviewSize ? maxPreviewSize : documento.dimensione)) {
      return true;
    }
    return false;
  }


  getMaxSizetByExtension(obj: MaxPreviewSize, ext: string) {
    if(!obj[ext]) {
      return obj["default"].maxSize;
    }
    return obj[ext].maxSize;
  }
  
  viewDoc(documento: DocumentoPct) {
    this.previewNavigate(documento);
  }

  previewNavigate(doc: DocumentoPct) {
    const fileName = doc.nome || '';
    const extension = fileName.split('.').pop()?.toUpperCase() || '';

    if (['PDF', 'ZIP', 'EML', 'P7M'].includes(extension)) {
      let fullUrl = null;
      let urlTree = null;
      let urlSerialized = null;

      switch (extension) {
        case 'EML':
          this.viewDocPreview(doc, 'message/rfc822', UrlSettingsCore.URL_EML_FILE_PREVIEW);
          break;
        case 'ZIP':
          this.viewDocPreview(doc, 'application/zip', UrlSettingsCore.URL_ZIP_FILE_PREVIEW);
          break;
        case 'PDF':
          this.viewDocPreview(doc, 'application/pdf', UrlSettingsCore.URL_PDF_FILE_PREVIEW);
          break;
        case 'P7M':
          this.viewP7mPreview(doc, 'application/pdf', UrlSettingsCore.URL_PDF_FILE_PREVIEW);
          break;
      }
      if(!urlTree) return;
      urlSerialized = this.router.serializeUrl(urlTree);
      fullUrl = `${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#${urlSerialized}?nomeFile=${encodeURIComponent(doc.nome)}`;
      window.open(fullUrl, '_blank');
    }
  }

  async viewP7mPreview(doc: DocumentoPct, mimeType: string, route: string) {
    const token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    this.actService.viewPrevieP7m(token, this.idFascicoloTlf, doc.idDocumentoPct, doc.refId).subscribe(
      {
        next: async (blob: Blob) => {
          if(!blob) {
           this.dialogNoPreview();
           return
          }
          this.showPreview(blob, doc, blob.type, route);
        },
        error: (err) => {
          console.log('Errore nel download del documento:', err);
        }
      }
    )
  }

  private dialogNoPreview() {
    this.dialog.open(ConfirmModalComponent, {
      data: {
        modalConfirm: {
          text: "Anteprima non supportata per questo documento",
          hideButtons: true,
          confirmButton: true
        },
        style: { width: "30%" },
        title: "Errore",
      }
    });
  }

  async viewDocPreview(doc: DocumentoPct, mimeType: string, route: string): Promise<void> {
    // Recupero il token da localStorage
    const token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    //Uso actService.downloadViewDoc(...) per ottenere il Blob del documento
    this.actService.downloadViewDoc(token, this.idFascicoloTlf, doc.idDocumentoPct, doc.refId)
      .subscribe({
        next: async (blob: Blob) => {
          this.showPreview(blob, doc, mimeType, route);
        },
        error: (err) => {
          console.log('Errore nel download del documento:', err);
        }
      });
  }

  private async showPreview(blob: Blob, doc: DocumentoPct, mimeType, route) {
    const buffer = await blob.arrayBuffer();
    let content = this.docUtilityService.arrayBufferToBase64(buffer);
    const fileName = doc.nome || '';
    const url = `${window.location.origin + (location.pathname && location.pathname !== '' ? location.pathname : '/')}#/${route}/buffer?nomeFile=${encodeURIComponent(fileName)}`;
    const newWindow = window.open(url, '_blank');
    if (!newWindow) {
      console.log('Impossibile aprire una nuova finestra. Pop-up bloccato?');
      return;
    }
    const listener = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;
      if (event.data === 'child_ready') {
        newWindow.postMessage({
          content: content,
          name: fileName,
          mimeType: mimeType
        }, window.location.origin);
        window.removeEventListener('message', listener);
      }
    };

    window.addEventListener('message', listener, false);
  }

}
